module.exports = new __parcel__URL__("jsm-storage-limit.061b8778.png").toString();